const idsMatch = (firstId, secondId) => String(firstId) === String(secondId);

const updateFeatureEntry = (features, partId, featureId, oldFeatureId) => {
  if (!Array.isArray(features)) {
    return features;
  }

  let hasChanges = false;
  const updatedFeatures = features.map(feature => {
    const matchesPart = feature.partId
      ? feature.partId === partId
      : oldFeatureId && idsMatch(feature.featureId, oldFeatureId);

    if (!matchesPart || idsMatch(feature.featureId, featureId)) {
      return feature;
    }

    hasChanges = true;
    return {...feature, featureId};
  });

  return hasChanges ? updatedFeatures : features;
};

// A cart item can represent either the shape itself or its parent material/style.
// Keep those IDs separate so cabinet color synchronization cannot replace the cabinet box model.
export const syncPersistedSqftShapeFeature = (shape, desiredFeature) => {
  if (!shape || !desiredFeature?.featureId || !desiredFeature.partId) {
    return shape;
  }

  const hasMatchingFeatureEntry = Array.isArray(shape.features)
    && shape.features.some(feature => feature.partId === desiredFeature.partId);
  const isShapeFeature = desiredFeature.partId === shape.partId
    || (!shape.partId && hasMatchingFeatureEntry);
  const isParentFeature = desiredFeature.partId === shape.parentPartId;

  if (!isShapeFeature && !isParentFeature) {
    return shape;
  }

  const updatedFeatures = updateFeatureEntry(
    shape.features,
    desiredFeature.partId,
    desiredFeature.featureId,
    desiredFeature.oldFeatureId
  );
  let featureId = shape.featureId;
  let relatedParentFeatureId = shape.relatedParentFeatureId;

  if (isParentFeature) {
    relatedParentFeatureId = desiredFeature.featureId;

    // QCDES-8812 briefly wrote the parent color ID into featureId. The original
    // cabinet box ID is still present in the shape-specific features entry.
    const shapeFeature = Array.isArray(updatedFeatures)
      ? updatedFeatures.find(feature => feature.partId === shape.partId)
      : null;
    if (shapeFeature?.featureId) {
      featureId = shapeFeature.featureId;
    }
  } else {
    featureId = desiredFeature.featureId;
  }

  const hasChanges = !idsMatch(featureId, shape.featureId)
    || !idsMatch(relatedParentFeatureId, shape.relatedParentFeatureId)
    || updatedFeatures !== shape.features;

  if (!hasChanges) {
    return shape;
  }

  return isParentFeature
    ? {...shape, featureId, relatedParentFeatureId, features: updatedFeatures}
    : {...shape, featureId, features: updatedFeatures};
};
